import { authRequiredForSecondaryOpsExp } from './constants';
import { getErrorMessage } from './getErrorMessage';

export const isAuthRequiredForSecondaryOps = (error: unknown): boolean => {
	return authRequiredForSecondaryOpsExp.test(getErrorMessage(error));
};
